import AddImage from './addImage.svg';

export default AddImage;
